import React, { useEffect, useCallback } from 'react';
import CloseIcon from '@mui/icons-material/Close';

import { useSelector, useDispatch } from 'react-redux';
import { selectVersionBanner } from '../../store/ui/ui.selector';
import { changeVersionBannerVisible } from '../../store/ui/ui.slice';

import './version-banner.styles.scss';

export default function VersionBanner() {
  const dispatch = useDispatch();
  const { visible, number } = useSelector(selectVersionBanner);

  const hideComponent = useCallback(() => dispatch(changeVersionBannerVisible(false)), [dispatch]);

  // Hides component after 10 sec
  useEffect(() => {
    const timeId = setTimeout(hideComponent, 10000);

    return () => {
      clearTimeout(timeId);
    };
  }, [hideComponent]);

  return (
    <div className={`version-banner ${visible && 'visible'}`}>
      <div className='close-banner-btn' onClick={hideComponent}>
        <CloseIcon />
      </div>
      <div className='version-text'>
        You are currently viewing Version {number} of CHaMP. Please have patience and
        provide us with feedback as we continue to improve this tool. Thank you!
      </div>
    </div>
  );
}
